var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 11.25C5.7875 11.25 5.6095 11.178 5.466 11.034C5.322 10.8905 5.25 10.7125 5.25 10.5V6.75H1.5C1.2875 6.75 1.10925 6.678 0.96525 6.534C0.82175 6.3905 0.75 6.2125 0.75 6C0.75 5.7875 0.82175 5.60925 0.96525 5.46525C1.10925 5.32175 1.2875 5.25 1.5 5.25H5.25V1.5C5.25 1.2875 5.322 1.10925 5.466 0.96525C5.6095 0.82175 5.7875 0.75 6 0.75C6.2125 0.75 6.39075 0.82175 6.53475 0.96525C6.67825 1.10925 6.75 1.2875 6.75 1.5V5.25H10.5C10.7125 5.25 10.8905 5.32175 11.034 5.46525C11.178 5.60925 11.25 5.7875 11.25 6C11.25 6.2125 11.178 6.3905 11.034 6.534C10.8905 6.678 10.7125 6.75 10.5 6.75H6.75V10.5C6.75 10.7125 6.67825 10.8905 6.53475 11.034C6.39075 11.178 6.2125 11.25 6 11.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddSvg);
export default __webpack_public_path__ + "static/media/AddSvg.7fe5018dc371564d8edb1e440caceecb.svg";
export { ForwardRef as ReactComponent };